import {
  bulkUpdateBlacklist,
  createBlacklist,
  deleteBlacklist,
  downloadBlacklistFiles,
  searchBlacklist,
  updateBlacklist,
  getBlacklistClassification,
  bulkUpdateBlacklistClassification,
  getBlacklistSetting,
} from './blacklist';
import {
  deleteCautionCustomers,
  searchCautionCustomers,
  getCautionClassification,
  createCautionCustomers,
  updateCautionCustomers,
  bulkUpdateCautionCustomers,
} from './cautionCustomers';

import { getAiCreditReportList } from '@/shared/api/aiCredit';
import { getAiCreditSetting, updateAiCreditSetting } from '@/shared/api/aiCreditSetting';
import { getCheckReportStatus, getJwtToken, getAiReportStatus } from '@/shared/api/aiReport';
import { getApiAuthInformation } from '@/shared/api/apiAuthInformation';
import { authorizeUser, refreshAccessToken } from '@/shared/api/auth';
import {
  bankruptSearchFileDownload,
  bankruptSearchFileUpload,
  getBankruptSearchFileUploadList,
  getBankruptSearchResultList,
} from '@/shared/api/bankruptSearch';
import { getCompletedStatus, updateCompleted } from '@/shared/api/checkCommentMention';
import {
  getCheckDecisions,
  createCheckDecision,
  updateCheckDecision,
  deleteCheckDecision,
  checkDecisionFileDownload,
  bulkRegisterCheckDecision,
} from '@/shared/api/checkDecision';
import {
  allExecution,
  execution,
  reExecution,
  executionErrorCheck,
  entityTypeCheck,
} from '@/shared/api/checkExecution';
import {
  getCheckNoticeSetting,
  createCheckNoticeSetting,
  updateCheckNoticeSetting,
  deleteCheckNoticeSetting,
} from '@/shared/api/checkNoticeSetting';
import {
  pdfDownloadCheckResultsDetail,
  downloadCheckResultDetailFiles,
  getCheckResultDetailCheckCondition,
  searchCheckResultDetailList,
  updateConfirmed,
} from '@/shared/api/checkResultDetail';
import { executeSingleRegistrySearch } from '@/shared/api/checkResultRegistry';
import {
  bulkOutputExcel,
  bulkUpdateClickAt,
  downloadCheckResultFiles,
  searchCheckResults,
  searchCheckResultsHistory,
  updateClickAt,
  deleteCheckResults,
} from '@/shared/api/checkResults';
import {
  createCheckConditionSettings,
  deleteCheckConditionSettings,
  getCheckConditionSettings,
  reflectionCheckConditionSettings,
  updateCheckConditionSettings,
} from '@/shared/api/conditionSettings';
import {
  creditExecution,
  creditReExecution,
  searchCreditManagements,
} from '@/shared/api/creditManagement';
import {
  getCreditManagementDownload,
  downloadCreditManagementFiles,
  uploadCreditManagementsFile,
  getCreditManagementExecuteStatus,
  getCreditManagementDownloadsExecuteStatus,
} from '@/shared/api/creditManagementDownload';
import { getCustomerInfoByExecutionHistory } from '@/shared/api/customerInfo';
import {
  createCustomerInformation,
  getCustomerInformation,
  updateCustomerInformation,
} from '@/shared/api/customerInformation';
import {
  bulkUpdateCustomers,
  customBulkUpdateCustomers,
  duplicateCheckCustomers,
  createCustomers,
  deleteCustomers,
  searchCustomers,
  updateCustomer,
  downloadCustomerFiles,
  getCustomBulkSetting,
  bulkUpdateEntityType,
  bulkUpdateCustomerUrl,
} from '@/shared/api/customers';
import {
  getCheckCount,
  getCheckCountHistory,
  getCheckExecutionHistory,
  getCreditManagementDownloadHistory,
  getAiCreditHistory,
  getNoCheckCount,
  getNotice,
  getReducedTimeHistory,
  getReducedTimeMinutes,
  getCheckDecision,
  getUsageHistory,
  getGroupUsageHistory,
  getAccountUsageHistory,
  getOtherUsageHistory,
  getRegistryDownloadHistory,
} from '@/shared/api/dashboard';
import {
  complianceExtractData,
  downloadExcelCompliance,
  downloadExcelData,
  downloadExtractionDataPdf,
  getDataExtraction,
  getPreview,
  putDataExtraction,
} from '@/shared/api/dataExtraction';
import { fileUpload } from '@/shared/api/file';
import {
  downloadFilesForFileManagement,
  getFileManagementFiles,
} from '@/shared/api/fileManagement';
import { getFolders } from '@/shared/api/folder';
import {
  createFolderList,
  deleteFolderList,
  getFolderList,
  getFolderSettings,
  updateFolderList,
  updateFolderSetting,
} from '@/shared/api/folderManagement';
import { postFunctionUsage } from '@/shared/api/functionUsage';
import { getGroups } from '@/shared/api/group';
import { getExecutives, getRegistrationReasons } from '@/shared/api/masters';
import {
  getNewspaperConditionSettings,
  updateNewspaperConditionSettings,
} from '@/shared/api/newspaperCondition';
import { getOverseasInvestigationAuthUrl } from '@/shared/api/overseasInvestigation';
import {
  deleteUploadedPdf,
  getPdfFiles,
  postPdfFilesExtraction,
  uploadPdf,
} from '@/shared/api/pdf';
import {
  deleteRegistryGets,
  executeRegistryMergeFromAcquisitions,
  getDuplicateCompanies,
  getRegistriesAuto,
  getRegistryGets,
  postRegistryGets,
  reacquisition,
  searchRegistries,
} from '@/shared/api/registries';
import {
  downloadSpnReport,
  getSpnSearchResults,
  getSpnServiceCodes,
  submitSpnRiskSupport,
} from '@/shared/api/spn';
import { getSprsRetentionSetting } from '@/shared/api/sprsRetentionSetting';
import { getToukiGroup } from '@/shared/api/toukiGroup';
import {
  deleteToukiPdf,
  getToukiPdfList,
  registerManualUpload,
  uploadToukiPdf,
} from '@/shared/api/toukiPdf';
import { getUsageCount } from '@/shared/api/usageCount';
import { getMentionUsers } from '@/shared/api/user';
import {
  getWcItems,
  getIdentityDocumentLocationTypes,
  getDetailWithCustomer,
  getWorldCheckList,
} from '@/shared/api/worldCheck';

export default {
  usageCount: {
    get: getUsageCount,
  },
  functionUsage: {
    post: postFunctionUsage,
  },
  groups: {
    get: getGroups,
  },
  users: {
    getMentionUsers,
  },
  masters: {
    getExecutives,
    getRegistrationReasons,
  },
  toukiGroup: {
    get: getToukiGroup,
  },
  folders: {
    get: getFolders,
  },
  blacklist: {
    search: searchBlacklist,
    create: createBlacklist,
    bulkUpdate: bulkUpdateBlacklist,
    update: updateBlacklist,
    delete: deleteBlacklist,
    download: downloadBlacklistFiles,
    getBlacklistClassification,
    bulkUpdateBlacklistClassification,
    getBlacklistSetting,
  },
  cautionCustomers: {
    search: searchCautionCustomers,
    create: createCautionCustomers,
    bulkUpdate: bulkUpdateCautionCustomers,
    update: updateCautionCustomers,
    delete: deleteCautionCustomers,
    getCautionClassification,
  },
  customers: {
    search: searchCustomers,
    create: createCustomers,
    bulkUpdate: bulkUpdateCustomers,
    customBulkUpdate: customBulkUpdateCustomers,
    duplicateCheck: duplicateCheckCustomers,
    update: updateCustomer,
    delete: deleteCustomers,
    download: downloadCustomerFiles,
    bulkSetting: getCustomBulkSetting,
    bulkUpdateEntityType,
    bulkUpdateCustomerUrl,
  },
  checkNoticeSetting: {
    get: getCheckNoticeSetting,
    create: createCheckNoticeSetting,
    update: updateCheckNoticeSetting,
    delete: deleteCheckNoticeSetting,
  },
  checkExecution: {
    execution,
    allExecution,
    reExecution,
    errorCheck: executionErrorCheck,
    entityTypeCheck,
  },
  customerInformation: {
    get: getCustomerInformation,
    create: createCustomerInformation,
    update: updateCustomerInformation,
  },
  customerInfo: {
    getByExecutionHistory: getCustomerInfoByExecutionHistory,
  },
  checkConditionSettings: {
    get: getCheckConditionSettings,
    create: createCheckConditionSettings,
    update: updateCheckConditionSettings,
    delete: deleteCheckConditionSettings,
    reflection: reflectionCheckConditionSettings,
  },
  newspaperCondition: {
    get: getNewspaperConditionSettings,
    update: updateNewspaperConditionSettings,
  },
  checkResults: {
    search: searchCheckResults,
    getHistory: searchCheckResultsHistory,
    updateClickAt,
    download: downloadCheckResultFiles,
    bulkUpdateClickAt,
    bulkOutputExcel,
    deleteCheckResults,
  },
  checkResultRegistry: {
    executeSingle: executeSingleRegistrySearch,
  },
  checkResultDetail: {
    getCheckCondition: getCheckResultDetailCheckCondition,
    search: searchCheckResultDetailList,
    download: downloadCheckResultDetailFiles,
    singleDownload: pdfDownloadCheckResultsDetail,
    updateConfirmed,
  },
  spn: {
    getSearchResults: getSpnSearchResults,
    downloadReport: downloadSpnReport,
    getServiceCodes: getSpnServiceCodes,
    submitRiskSupport: submitSpnRiskSupport,
  },
  sprsRetentionSetting: {
    get: getSprsRetentionSetting,
  },
  checkDecision: {
    get: getCheckDecisions,
    create: createCheckDecision,
    update: updateCheckDecision,
    delete: deleteCheckDecision,
    download: checkDecisionFileDownload,
    bulkRegister: bulkRegisterCheckDecision,
  },
  checkCommentMention: {
    getCompleted: getCompletedStatus,
    update: updateCompleted,
  },
  folderSettings: {
    get: getFolderSettings,
    update: updateFolderSetting,
  },
  folderList: {
    get: getFolderList,
    create: createFolderList,
    update: updateFolderList,
    delete: deleteFolderList,
  },
  fileManagements: {
    get: getFileManagementFiles,
    download: downloadFilesForFileManagement,
  },
  creditManagementDownload: {
    get: getCreditManagementDownload,
    upload: uploadCreditManagementsFile,
    download: downloadCreditManagementFiles,
    getExecutionStatus: getCreditManagementExecuteStatus,
    getDownloadsExecutionStatus: getCreditManagementDownloadsExecuteStatus,
  },
  creditManagement: {
    search: searchCreditManagements,
    execution: creditExecution,
    reExecution: creditReExecution,
  },
  registries: {
    searchRegistries,
    deleteRegistryGets,
    reacquisition,
    getRegistriesAuto,
    getRegistryGets,
    postRegistryGets,
    getDuplicateCompanies,
    executeRegistryMergeFromAcquisitions,
  },
  dataExtraction: {
    downloadPdf: downloadExtractionDataPdf,
    downloadExcelData,
    downloadExcelCompliance,
    complianceExtractData,
    getDataExtraction,
    getPreview,
    putDataExtraction,
  },
  toukiDownload: {
    downloadPdf: async (params: { fileIds: number[] }) => {
      const { downloadToukiPdf } = await import('@/shared/api/dataExtraction');
      return downloadToukiPdf(params);
    },
    downloadExcel: async (params: { groupId: number; companyInformationIds: number[] }) => {
      const { downloadToukiExcel } = await import('@/shared/api/dataExtraction');
      return downloadToukiExcel(params);
    },
    downloadComplianceExcel: async (params: {
      groupId: number;
      companyInformationIds: number[];
    }) => {
      const { downloadToukiComplianceExcel } = await import('@/shared/api/dataExtraction');
      return downloadToukiComplianceExcel(params);
    },
  },
  pdf: {
    upload: uploadPdf,
    delete: deleteUploadedPdf,
    getList: getPdfFiles,
    postExtraction: postPdfFilesExtraction,
  },
  toukiPdf: {
    upload: uploadToukiPdf,
    getList: getToukiPdfList,
    delete: deleteToukiPdf,
    registerManualUpload,
  },
  auth: {
    authorizeUser,
    refreshAccessToken,
  },
  dashboard: {
    notice: {
      get: getNotice,
    },
    checkCountHistory: {
      get: getCheckCountHistory,
      getExecution: getCheckExecutionHistory,
      getCreditDownload: getCreditManagementDownloadHistory,
      getAiCredit: getAiCreditHistory,
    },
    reducedTime: {
      get: {
        minutes: getReducedTimeMinutes,
        history: getReducedTimeHistory,
      },
    },
    checkCount: {
      get: getCheckCount,
    },
    noCheckCount: {
      get: getNoCheckCount,
    },
    checkDecision: {
      get: getCheckDecision,
    },
    usageHistory: {
      get: getUsageHistory,
    },
    groupUsageHistory: {
      get: getGroupUsageHistory,
    },
    accountUsageHistory: {
      get: getAccountUsageHistory,
    },
    otherUsageHistory: {
      get: getOtherUsageHistory,
    },
    registryDownloadHistory: {
      get: getRegistryDownloadHistory,
    },
  },
  apiAuthInformation: {
    get: getApiAuthInformation,
  },
  file: {
    // NOTE: S3 upload用
    upload: fileUpload,
  },
  woldCheck: {
    getWcItems,
    getIdentityDocumentLocationTypes,
    getWorldCheckList,
    getDetailWithCustomer,
  },
  bankruptSearch: {
    getBankruptSearchResultList,
    getBankruptSearchFileUploadList,
    bankruptSearchFileUpload,
    bankruptSearchFileDownload,
  },
  aiCredit: {
    getReportList: getAiCreditReportList,
  },
  aiCreditSetting: {
    get: getAiCreditSetting,
    update: updateAiCreditSetting,
  },
  aiReport: {
    getJwtToken,
    getCheckReportStatus,
    getAiReportStatus,
  },
  overseasInvestigation: {
    getAuthUrl: getOverseasInvestigationAuthUrl,
  },
};
